import {
  Component,
  OnDestroy,
  OnInit} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import { AppConfig } from "../../../../../../../visa";
import { of, iif, EMPTY } from "rxjs";
import { SubSink } from "subsink2";
import { delay, mergeMap } from 'rxjs/operators';
import { BranchSettingsFacade } from '../../../../../facades/branch-settings.facade';
//import { PrintableSearchModel } from '../../../../../models/advanced-search-models/printable-search.model';
import { ViewColumnComponent } from '../../../../../../../view-column.component';
import { BranchSettingsSelectors } from '../../../../../branch-settings-controller/selectors';
import { BranchSettingsActions} from '../../../../../branch-settings-controller/actions';
import { BranchSettingsStates } from '../../../../../branch-settings-controller/states';
import { ComponentStore } from '@ngrx/component-store';
import { HttpClient, HttpHeaders } from '@angular/common/http';

interface LocalState {
  deactivateReturn: boolean;
  deactivateList: boolean;
  selectedIndex: number;
  deactivateAdd:boolean;
  deleteConfirmation: boolean;
}
@Component({
  selector: "app-branch-printable-image-link-edit",
  templateUrl: "./edit.component.html",
  styleUrls: ["./edit.component.css"],
  providers: [ComponentStore]
})
export class BranchPrintableImageLinkEditComponent  extends ViewColumnComponent implements OnInit, OnDestroy {
  protected subs = new SubSink();
  apiVisa = AppConfig.apiVisa;
  protected compName = 'Create Pricing Scheme';
  protected index = 4;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deleteConfirmation$ = this.componentStore.select(state => state.deleteConfirmation);

  guid;
  branchGuid;
  form: FormGroup;
  deleteConfirmation = false;
  src;
  imageUrl;
  constructor(
    private http: HttpClient,
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState(a);
    });
    this.form = new FormGroup({
      imageCode: new FormControl(),
      imageName: new FormControl()
    })
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectPrintableImageLink).subscribe(async (p: any) => {
      this.guid = p.guid;
      const propertyJson = <any>p.bl_prt_printable_format_image_hdr_acl_config;
      this.imageUrl = this.apiVisa.api_domain_url + 'core2/tnt/dm/prt/printable-format/image-hdrs/backoffice-ep/pub/file/' + p.image_guid + '?tenantCode=' + this.apiVisa.tenantCode;
      this.src = await this.downloadImage(propertyJson?.file_name);

      this.form.patchValue({
        imageCode: p.bl_prt_printable_format_image_hdr_image_code,
	      imageName: p.bl_prt_printable_format_image_hdr_image_name
      })
    })
    this.subs.sink = this.deleteConfirmation$.pipe(
      mergeMap(a => {
        return iif(() => a, of(a).pipe(delay(3000)), of(EMPTY));
      })
    ).subscribe(resolve => {
      if (resolve === true) {
        this.componentStore.patchState({deleteConfirmation: false});
        this.deleteConfirmation = false;
      }
    });
  }

  async downloadImage(fileName: string) {
    const Authorization = localStorage.getItem('authToken');
    const headers = new HttpHeaders({ Authorization });
    const imageBlob = await this.http
      .get(this.imageUrl, { headers, responseType: 'blob' })
      .toPromise();
    const reader = new FileReader();
    console.log("Image Blob",imageBlob);

    if(imageBlob.size!==0){
      return await new Promise<string>((resolve, reject) => {
        console.log("Data Image", resolve);
        reader.onloadend = () => setTimeout(resolve,2000,reader.result as string);
        reader.readAsDataURL(imageBlob);
        //this.uploadedFile = new File([imageBlob], fileName, { type: imageBlob.type });
      })
    }else{
      return null;
    }
  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }


  onDelete(){
    if (this.deleteConfirmation) {
      this.branchSettingsStore.dispatch(BranchSettingsActions.deletePrintableImageLinkInit({guid: this.guid}));
      this.deleteConfirmation = false;
      this.componentStore.patchState({deleteConfirmation: false});
    } else {
      this.deleteConfirmation = true;
      this.componentStore.patchState({deleteConfirmation: true});
    }
  }
}
